module.exports = __webpack_public_path__ + "680102d49ded5b4d45f8349f0afc888c.svg";